import { FC, HTMLAttributes } from "react";
import { Resizable, ResizeCallbackData } from 'react-resizable';

interface ResizableTitleProps extends Omit<HTMLAttributes<any>, 'onResize'> {
  onResize: (e: React.SyntheticEvent<Element>, data: ResizeCallbackData) => void;
  width: number;
};
/** 可拖动列 */
const ResizableTitle: FC<ResizableTitleProps> = props => {
  const { onResize, width, ...restProps } = props;
  if (!width) {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTitle;
